<template>
  <div class="person-info">
    <div class="template-title">参赛人员资料</div>
    <div class="player-content">
      <PlayerInfo />
      <time-out :count='teachingTime' @timeIsOvered='timeIsOvered' title="距离上传结束"/>
    </div>
    <div class="template-title margin-bt">上传教学反思材料</div>
    <div v-if="hasSubmitted" class="submitted-file">
      <img class="submitted-file-icon" :src="activeDocIcon" alt="教学反思文件">
      <span class="submitted-file-name">{{asyncPosters.name}}</span>
      <span class="submitted-file-preview" @click="previewFile">在线预览</span>
    </div>
    <div v-else>
      <upload-view
        type='doc,pdf'
        :fileDesc="''"
        :tag="''"
        :deleteable="true"
        :img='""'
        :icon='defaultDocIcon'
        :activeIcon='activeDocIcon'
        :index='0'
        :path='asyncPosters.url'
        :name='asyncPosters.name'
        :activityId="activityId"
        :playerId="playerId"
        :couldPreview="!!asyncPosters.url"
        :changeObj="{show: '', text: ''}"
        @uploadSucc='uploadPosterSuccess'
        @deleteFile='cancleImg'
        @preview='previewFile'
      >
      </upload-view>
    </div>
    <div class="tips">文件大小: 小于等于10M</div>
    <div v-if="hasSubmitted" class="submitted-tip">教学反思已提交，祝您取得理想成绩。</div>
    <el-button v-else type="primary" class="btn-submit" @click="confirmSubmit">提交</el-button>
  </div>
</template>
<script>
import { uploadTeaching, sendUploadSummarymaterialSuccess } from '@/service/teaching'
import PlayerInfo from '@/components/player-info/index'
import TimeOut from '@/components/time-out/index'
import UploadView from '@/components/upload-view'
export default {
  components: {
    PlayerInfo,
    TimeOut,
    UploadView
  },
  data () {
    return {
      asyncPosters: {
        name: '',
        host: '',
        url: '',
        size: ''
      },
      defaultDocIcon: require('@/assets/images/teaching-default.png'),
      activeDocIcon: require('@/assets/images/teaching-active.png'),
      teachingTime: 0,
      reflectionTime: 0,
      playerId: '',
      activityId: '',
      hasSubmitted: false
    }
  },
  created () {
    this.getInitData()
  },
  methods: {
    /**
     * 反思材料上传倒计时结束提示。
     *
     * 该方法只负责提醒用户上传时间已经结束，不会主动禁用上传组件或提交按钮，
     * 最终是否允许逾期提交仍应以后端接口的校验结果为准。
     */
    timeIsOvered () {
      this.$alert('撰写教学反思的时间已经结束，请您尽快提交哦!', '消息提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'danger'
      }).then(() => {})
    },

    /**
     * 通知 Socket 服务“教学反思材料已提交成功”。
     *
     * 调用时机：`summary_material` 保存成功之后。
     * 该接口只用于向其他业务端广播成功状态，不负责保存教学反思文件，
     * 因此真正的提交结果应以 `uploadTeaching` 接口为准。
     * 通知成功后显示成功弹窗，并返回登录时记录的原始入口地址。
     */
    sendUploadSummarymaterialSuccessHandler () {
      let userInfo = JSON.parse(localStorage.getItem('PersonInfo')).user
      let params = {
        namespace: 'uploadSummarymaterialSuccess',
        payload: {
          activity_id: userInfo.activity_id,
          group_id: userInfo.group_id,
          player_id: userInfo.id,
          status: 'success'
        }
      }
      sendUploadSummarymaterialSuccess(params).then(res => {
        this.$alert('内容上传成功，祝您取得好成绩', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'success'
        }).then(() => {
          this.$router.replace(`${sessionStorage.getItem('searchParams')}`)
        })
      })
    },

    /**
     * 初始化教学反思页面所需的数据。
     *
     * 1. 从登录后缓存的 `PersonInfo` 中取得活动和选手信息；
     * 2. 从活动的 `contest_summary` 模块读取允许上传的分钟数；
     * 3. 使用“现场教学结束时间 + 反思时长 - 浏览器当前时间”计算剩余秒数。
     *
     * 页面依赖登录流程提前写入 `localStorage.PersonInfo` 和
     * `sessionStorage.teachingStartTime`，直接访问路由时需确保这些数据存在。
     */
    getInitData () {
      const activityInfo = JSON.parse(localStorage.getItem('PersonInfo')).activity
      const userInfo = JSON.parse(localStorage.getItem('PersonInfo')).user
      this.activityId = activityInfo.id
      this.playerId = userInfo.id
      this.fillSubmittedFile(userInfo.contest_summary, activityInfo)
      let modules = activityInfo.modules
      let prospect = 0
      for (let i in modules) {
        if (modules[i].category === 'summaries' && modules[i].module === 'contest_summary') {
          prospect = modules[i].properties.duration_minutes ? modules[i].properties.duration_minutes * 60 : 0
        }
      }
      let endSecond = sessionStorage.getItem('teachingStartTime') / 1
      let currentSecond = new Date().getTime() / 1000
      let diffSecond = prospect + endSecond - currentSecond
      this.reflectionTime = 3600
      this.teachingTime = diffSecond > 0 ? diffSecond : 0
    },

    /**
     * 回填已经完成业务提交的教学反思文件。
     *
     * 登录响应中的 `user.contest_summary.url` 是当前页面判断已提交的依据。
     * 已提交时不再渲染公共上传组件，改为展示本页面自己的只读文件卡片，
     * 从而只保留预览能力，不影响 `upload-view` 的其他使用页面。
     *
     * @param {Object} contestSummary 登录响应中的教学反思记录
     * @param {Object} activityInfo 活动数据，用于缺少文件 host 时兜底
     */
    fillSubmittedFile (contestSummary, activityInfo) {
      if (!contestSummary || !contestSummary.url) {
        return
      }
      this.asyncPosters.name = this.getSubmittedFileName(contestSummary)
      this.asyncPosters.host = contestSummary.host || contestSummary.oss_host || activityInfo.host || ''
      this.asyncPosters.url = contestSummary.url
      this.asyncPosters.size = contestSummary.size || ''
      this.hasSubmitted = true
    },

    /**
     * 兼容不同历史字段并生成已提交文件的展示名称。
     *
     * @param {Object} file 教学反思记录
     * @returns {String} 文件展示名称
     */
    getSubmittedFileName (file) {
      const name = file.name || file.file_name || file.filename || file.title
      if (name) {
        return name
      }
      const url = String(file.url || '').split('?')[0].split('#')[0]
      const filename = url.substring(url.lastIndexOf('/') + 1)
      try {
        return decodeURIComponent(filename) || '已提交的教学反思'
      } catch (e) {
        return filename || '已提交的教学反思'
      }
    },

    /**
     * 将本次成功提交的文件同步到登录缓存。
     *
     * 页面重新进入时仍然通过 `user.contest_summary` 回填。这里同步缓存可避免
     * 在尚未重新登录获取最新用户数据前，直接重进页面又显示成可上传状态。
     */
    syncSubmittedFileToStorage () {
      const personInfoString = localStorage.getItem('PersonInfo')
      if (!personInfoString) {
        return
      }
      try {
        const personInfo = JSON.parse(personInfoString)
        if (!personInfo.user) {
          return
        }
        const contestSummary = personInfo.user.contest_summary || {}
        contestSummary.name = this.asyncPosters.name
        contestSummary.host = this.asyncPosters.host
        contestSummary.url = this.asyncPosters.url
        contestSummary.size = String(this.asyncPosters.size)
        personInfo.user.contest_summary = contestSummary
        localStorage.setItem('PersonInfo', JSON.stringify(personInfo))
      } catch (e) {
        // 缓存同步失败不改变服务端已经提交成功的事实。
      }
    },

    /**
     * 生成可用于浏览器或 Office Online 打开的文件地址。
     *
     * OSS 回调可能返回完整 URL，也可能只返回对象路径：
     * - HTTP/HTTPS 地址直接使用；
     * - `//host/path` 补充当前页面协议；
     * - 相对路径使用上传时保存的 OSS host 进行拼接。
     *
     * @returns {String} 文件预览地址
     */
    getPreviewUrl () {
      const url = String(this.asyncPosters.url || '')
      if (/^https?:\/\//i.test(url)) {
        return url
      }
      if (/^\/\//.test(url)) {
        return window.location.protocol + url
      }
      const host = String(this.asyncPosters.host || '')
      if (!host) {
        return url
      }
      return host.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
    },

    /**
     * 在线预览当前教学反思文件。
     *
     * 该方法同时服务于“OSS 已上传、业务待提交”和“业务已提交回填”两种状态。
     * PDF 使用浏览器新窗口直接打开；Word（doc/docx）通过 Microsoft
     * Office Online Viewer 打开。Office Online 必须能够通过公网 HTTP/HTTPS
     * 访问源文件，因此相对地址、内网地址或需要额外登录鉴权的地址无法预览。
     * 不支持的文件类型会给出提示，不执行跳转。
     */
    previewFile () {
      const url = this.getPreviewUrl()
      if (!url) {
        this.$message({ type: 'warning', message: '文件地址不存在，无法预览' })
        return
      }
      const filePath = `${this.asyncPosters.name || ''} ${url}`.split('?')[0].split('#')[0].toLowerCase()
      if (/\.pdf(?:\s|$)/.test(filePath)) {
        window.open(url, '_blank')
        return
      }
      if (/\.docx?(?:\s|$)/.test(filePath)) {
        if (!/^https?:\/\//i.test(url)) {
          this.$message({ type: 'warning', message: 'Word 在线预览需要完整的公网文件地址' })
          return
        }
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url), '_blank')
        return
      }
      this.$message({ type: 'warning', message: '当前文件格式暂不支持在线预览' })
    },

    /**
     * 接收通用上传组件的 OSS 上传成功事件。
     *
     * 此时文件只完成了 OSS 上传，尚未调用 `summary_material` 完成业务提交。
     * 将返回值暂存在 `asyncPosters` 后，页面会立即显示文件名和预览按钮，
     * 用户确认无误后仍需点击底部“提交”按钮。
     *
     * @param {String} path OSS 返回的文件路径
     * @param {String} name 用户选择的原始文件名
     * @param {String} host OSS 文件主机地址
     * @param {Number} size 文件字节数
     */
    uploadPosterSuccess (path, name, host, size) {
      this.asyncPosters.name = name
      this.asyncPosters.host = host
      this.asyncPosters.url = path
      this.asyncPosters.size = size
    },

    /**
     * 清空当前尚未提交的文件展示状态。
     *
     * 该操作只清除页面内存中的文件信息，不会删除已经上传到 OSS 的对象。
     */
    cancleImg () {
      this.asyncPosters.host = ''
      this.asyncPosters.name = ''
      this.asyncPosters.url = ''
      this.asyncPosters.size = ''
    },

    /**
     * 提交教学反思业务数据。
     *
     * 提交前检查是否已经完成 OSS 上传并取得文件路径。
     *
     * 校验通过后调用 `summary_material` 保存文件路径和大小；保存成功后切换
     * 已提交只读状态、同步本地缓存，再发送 Socket 成功通知。
     */
    confirmSubmit () {
      if (this.hasSubmitted) {
        this.$message({ type: 'warning', message: '教学反思已提交，祝您取得理想成绩。' })
        return false
      }
      if (!this.asyncPosters.url) {
        this.$message({ type: 'warning', message: '请上传教学反思！' })
        return false
      }
      let params = {
        url: this.asyncPosters.url,
        size: String(this.asyncPosters.size)
      }
      uploadTeaching(this.playerId, this.activityId, params).then(res => {
        if (res.status !== 'success') {
          this.$message({ type: 'warning', message: res.msg })
          return
        }
        this.hasSubmitted = true
        this.syncSubmittedFileToStorage()
        this.sendUploadSummarymaterialSuccessHandler()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.person-info {
  width: 100%;
  max-width: 686px;
  margin: 0 auto;
  padding-top: 25px;
}

.template-title {
  font-size: 20px;
  font-weight: 600;
  color: #4E5A73;
  padding-left: 10px;
  position: relative;
  &::before {
    content: '';
    width: 6px;
    height: 20px;
    background: #F04037;
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.player-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 26px 0;
}

.margin-bt {
  margin-bottom: 26px;
}

.submitted-file {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 15px 10px;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}

.submitted-file-icon {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  margin-right: 20px;
  object-fit: contain;
}

.submitted-file-name {
  flex: 1;
  color: #4E5A73;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  word-break: break-all;
}

.submitted-file-preview {
  flex-shrink: 0;
  margin-left: 20px;
  color: #F04037;
  cursor: pointer;
}

.submitted-tip {
  margin-top: 40px;
  color: #68BF7B;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.btn-submit {
  margin-top: 74px;
  width: 180px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #F04037;
  border-radius: 4px;
  padding: 0;
  font-size: 16px;
  color: #fff;
  display: block;
  margin: 74px auto auto;
}
</style>



// WEBPACK FOOTER //
// src/views/teachingRelection.vue